import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiMangaGeneratorConfig } from '@/data/landingConfig/landingAiMangaGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiMangaGenerator } from './schemaObject';

interface Props {}
const AiMangaGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiMangaGenerator} />
			<LandingTemplate
				data={landingAiMangaGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAnimeGenerator()}
			/>
		</>
	);
};

export default AiMangaGenerator;
